import React from "react";
import logo from "../../shared/assets/images/logoFooter.svg";
import S from './Footer.module.scss';
import {useNavigate} from "react-router-dom";
import {useScrollToSection} from "../../shared/hook/useScrollToSection";
import backgroundFooter from '../../shared/assets/images/backgroundFooter.png';
import backgroundFooterMini from '../../shared/assets/images/backgroundFooterMini.png';
import vk from '../../shared/assets/images/vk2.png';
import rutube from '../../shared/assets/images/rutube.png';

export const Footer = () => {
  const scrollToSection = useScrollToSection();
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();

  return (
      <div className={S.footer} id='contacts'>
        <div className={S.backgroundFooterMini}>
          <img src={backgroundFooterMini} alt="backgroundFooterMini"/>
        </div>
        <div className={S.footer_container}>
          <div className={S.footer_content}>
            <div className={S.footer_logo} onClick={() => scrollToSection('announcements')}>
              <img src={logo} alt="Logo"/>
            </div>

            <div className={S.footer_menu}>
              <a className={S.menu_item} onClick={() => scrollToSection('announcements')}>Мероприятия</a>
              <a className={S.menu_item} onClick={() => scrollToSection('about')}>О нас</a>
              <a className={S.menu_item} onClick={() => scrollToSection('archive')}>Архив</a>
              <a className={S.menu_item} onClick={() => scrollToSection('partners')}>Партнёры</a>
              <a className={S.menu_item}>Контакты</a>
            </div>

            <div className={S.footer_contacts}>
              <div className={S.contacts_block}>
                <div className={S.contact_item}>
                  <span className={S.contact_label}>Телефон</span>
                  <a href="tel:+79220197166" className={S.contact_value}>+7 (922) 019-71-66</a>
                </div>
                <div className={S.contact_item}>
                  <span className={S.contact_label}>E-mail</span>
                  <a href="mailto:info@evoforum.ru" className={S.contact_value}>info@evoforum.ru</a>
                </div>
              </div>
            </div>
            <div className={S.footer_contacts}>
              <div className={S.contacts_block}>
                <div className={S.contact_item}>
                  <span className={S.contact_label}>
                    <img src={vk} alt="vk"/>
                  </span>
                  <a href="https://vk.ru/club241247865" target="_blank" rel="noreferrer" className={S.contact_value}>
                    vk.ru/evoforum
                  </a>
                </div>
                <div className={S.contact_item}>
                  <span className={S.contact_label}>
                    <img src={rutube} alt="rutube"/>
                  </span>
                  <a href="https://rutube.ru/channel/80952490" target="_blank" rel="noreferrer" className={S.contact_value}>
                    rutube.ru/evoforum
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className={S.footer_bottomContent}>
          <div className={S.copyright}>
              © {currentYear} ООО Эвофорум, Все права защищены
            </div>
            <div className={S.privacy_policy} onClick={() => navigate('/privacy-policy')}>
              Политика конфиденциальности
            </div>
          </div>
        </div>
        <div className={S.backgroundFooter}>
          <img src={backgroundFooter} alt="backgroundFooter"/>
        </div>
      </div>
  );
}